import { BASE_URL } from '../components/AppConfig';
import { handleDynamicRequestHeader, handleDynamicRequestHeaderMulter } from '../components/DyanamicRequest';

const getAuthToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  return sessionToken ? `Bearer ${sessionToken}` : '';
};

// List banners
export const getBanners = async (limit = 50, offset = 0) => {
  return new Promise((resolve) => {
    const token = getAuthToken();
    const url = `${BASE_URL}/admin/banners?limit=${limit}&offset=${offset}`;
    handleDynamicRequestHeader('GET', url, null, token, () => resolve({ statusCode: '50000', message: 'Failed to fetch banners' }), (response) => resolve(response));
  });
};

// Get one banner
export const getBanner = async (id) => {
  return new Promise((resolve) => {
    const token = getAuthToken();
    handleDynamicRequestHeader('GET', `${BASE_URL}/admin/banners/${id}`, null, token, () => resolve({ statusCode: '50000', message: 'Failed to fetch banner' }), (response) => resolve(response));
  });
};

// Create banner (multipart: optional image; body: type, template, priority, expiry?, click_tracking_id?, title?, subtitle?, cta_url?, cta_text?, color_1?, color_2?)
export const createBanner = async (formData) => {
  return new Promise((resolve) => {
    const token = getAuthToken();
    handleDynamicRequestHeaderMulter(
      'POST',
      `${BASE_URL}/admin/banners`,
      formData,
      token,
      () => resolve({ statusCode: '50000', message: 'Failed to create banner' }),
      (response) => resolve(response)
    );
  });
};

// Update banner (same body + optional image). Backend should invalidate home:banners cache.
export const updateBanner = async (id, formData) => {
  return new Promise((resolve) => {
    const token = getAuthToken();
    handleDynamicRequestHeaderMulter(
      'PUT',
      `${BASE_URL}/admin/banners/${id}`,
      formData,
      token,
      () => resolve({ statusCode: '50000', message: 'Failed to update banner' }),
      (response) => resolve(response)
    );
  });
};

// Delete banner. Backend should invalidate home:banners cache.
export const deleteBanner = async (id) => {
  return new Promise((resolve) => {
    const token = getAuthToken();
    fetch(`${BASE_URL}/admin/banners/${id}`, {
      method: 'DELETE',
      headers: { Authorization: token },
    })
      .then((res) => res.json())
      .then((data) => resolve(data || { statusCode: '50000', message: 'Failed to delete banner' }))
      .catch(() => resolve({ statusCode: '50000', message: 'Failed to delete banner' }));
  });
};
